import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FsbcamposService {

  constructor(
    private http: HttpClient
  ) { }

  getCampos(rotina: any) {
    let link = `${environment.protheus}/campos?rotina=${rotina}`;
    return this.http.get(link);
  }
}